import { ArrowIcon } from "assets/icons";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { Icon } from "ui";

import { LinkWithArrowProps } from "./LinkWithArrow.types";

import styles from "./LinkWithArrow.module.scss";

const LinkWithArrow = ({ to, text, className }: LinkWithArrowProps) => {
  return (
    <Link to={to} target="_blank" className={`${styles.link} ${className}`}>
      <span className={styles.link_text}>{t(text)}</span>
      <Icon
        as={ArrowIcon}
        boxSize={18}
        className={styles.link_arrow}
        color="#FB3973"
      />
    </Link>
  );
};

export default LinkWithArrow;
